// extracted by mini-css-extract-plugin
module.exports = {"menuDropdown":"menuDropdown_menuDropdown__3R74J","label":"menuDropdown_label__xDtwn"};